/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  SupportProgress,
  SupportersOverview
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Public list of everyone who has supported the project
 */
export const supporters = (

 signal?: AbortSignal
) => {


      return axiosClient<SupportersOverview>(
      {url: `/supporters`, method: 'GET', signal
    },
      );
    }




export const getSupportersQueryKey = () => {
    return [
    'supporters'
    ] as const;
    }


export const getSupportersQueryOptions = <TData = Awaited<ReturnType<typeof supporters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supporters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSupportersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supporters>>> = ({ signal }) => supporters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supporters>>, TError, TData>
}

export type SupportersQueryResult = NonNullable<Awaited<ReturnType<typeof supporters>>>
export type SupportersQueryError = ErrorType<unknown>


/**
 * @summary Public list of everyone who has supported the project
 */

export function useSupporters<TData = Awaited<ReturnType<typeof supporters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supporters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Supporters Progress
 */
export const supportersProgress = (

 signal?: AbortSignal
) => {


      return axiosClient<SupportProgress>(
      {url: `/supporters/progress`, method: 'GET', signal
    },
      );
    }




export const getSupportersProgressQueryKey = () => {
    return [
    'supporters','progress'
    ] as const;
    }


export const getSupportersProgressQueryOptions = <TData = Awaited<ReturnType<typeof supportersProgress>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportersProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSupportersProgressQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportersProgress>>> = ({ signal }) => supportersProgress(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportersProgress>>, TError, TData>
}

export type SupportersProgressQueryResult = NonNullable<Awaited<ReturnType<typeof supportersProgress>>>
export type SupportersProgressQueryError = ErrorType<unknown>


/**
 * @summary Public Supporters Progress
 */

export function useSupportersProgress<TData = Awaited<ReturnType<typeof supportersProgress>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportersProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportersProgressQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






